__turbopack_context__.v({
  "backBtn": "extracted-module__-ZdguG__backBtn",
  "container": "extracted-module__-ZdguG__container",
  "empty": "extracted-module__-ZdguG__empty",
  "grid": "extracted-module__-ZdguG__grid",
  "header": "extracted-module__-ZdguG__header",
  "icon": "extracted-module__-ZdguG__icon",
  "loading": "extracted-module__-ZdguG__loading",
  "stat": "extracted-module__-ZdguG__stat",
  "statLabel": "extracted-module__-ZdguG__statLabel",
  "statValue": "extracted-module__-ZdguG__statValue",
  "statsBar": "extracted-module__-ZdguG__statsBar",
  "subtitle": "extracted-module__-ZdguG__subtitle",
  "title": "extracted-module__-ZdguG__title",
  "titleRow": "extracted-module__-ZdguG__titleRow",
});
